/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetProject } from './project.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const PostProject = {
  id: 'project.post',
  tag: 'Project',
  summary: 'Post project',
  description: 'Create a project within an organization',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/project`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            name: ZodTypes.KubernetesIdentifier,
            description: z.string().min(1).optional().nullable(),
            thumbnail: ZodTypes.ThumbnailFormat.optional(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: GetProject.response['200'].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
